import { ActionKeys } from './constants';

export const openHelpChat = () =>
  <const>{
    type: ActionKeys.HELP_OPEN_CHAT,
  };

export const openHelpChatSuccess = () =>
  <const>{
    type: ActionKeys.HELP_OPEN_CHAT_SUCCESS,
  };

export type HelpActions = ReturnType<typeof openHelpChat> | ReturnType<typeof openHelpChatSuccess>;
